import { combineReducers } from 'redux-immutable';
import reduceReducers      from 'reduce-reducers';

import loading             from './loading';
import flexParameters      from './flexParameters';
import rigidFlexParameters from './rigidFlexParameters';
import parameters          from './parameters';
import crossParameters     from './crossParameters';
import quote               from './quote';
import quoteStep           from './quote_step';
import parametersChanged   from './parameters_changed';
import suppliers           from './suppliers';

const combinedReducers = combineReducers({
  loading,
  flexParameters,
  rigidFlexParameters,
  quote,
  quoteStep,
  suppliers,
  parametersChanged,
  parameters,
});

export default reduceReducers(
  combinedReducers,
  crossParameters,
);
